export default {
  compareHub: {
    seo: {
      title: 'Comparer les logiciels logistiques | Geofleet — plateforme agentique pour l’exécution',
      description:
        'Comparez Geofleet aux optimiseurs de tournées, outils du dernier kilomètre et plateformes de livraison enterprise. Tableau de synthèse et pages dédiées par éditeur — la plateforme logistique agentique pour une exécution réelle.',
    },
    breadcrumb: 'Comparer',
    hero: {
      lockupPartner: 'Autres plateformes',
      eyebrow: 'Comparaison de plateformes',
      h1Before: 'Comparez les logiciels logistiques — choisissez une couche d’exécution ',
      h1Highlight: 'agentique',
      h1After: '',
      leadBefore: 'La plupart des outils',
      leadEmphasis1: 'planifient ou notifient',
      leadMiddle: '. Geofleet est conçu pour',
      leadEmphasis2: 'faire tourner les opérations',
      leadAfter:
        ' : des AI Agents dans un centre de commande unifié alignent chauffeurs, transporteurs et clients quand les conditions changent — sans patchwork de tableaux de bord et de replanifications manuelles.',
      ctaTable: 'Voir le tableau comparatif',
      ctaTrial: 'Commencer',
      ctaDemo: 'Réserver une démo',
    },
    howToLabel: 'Comment utiliser cette page',
    steps: {
      overview: {
        title: 'Commencez par la vue d’ensemble',
        body: 'Voyez en un tableau comment Geofleet diffère des stacks routing, livraison et legacy typiques.',
      },
      vendor: {
        title: 'Approfondissez votre éditeur',
        body: 'Choisissez l’outil que vous utilisez — chaque page est un comparatif Geofleet vs éditeur détaillé.',
      },
      validate: {
        title: 'Validez sur votre réseau',
        body: 'Réservez une démo pour mapper hubs, transporteurs et volumes vers le centre de commande et les AI Agents.',
      },
    },
    pills: {
      command: {
        title: 'AI Command Centre',
        sub: 'Les agents coordonnent dispatch, tournées et exceptions ensemble',
      },
      live: {
        title: 'Exécution en direct',
        sub: 'Allocation et routes évoluent avec le réseau',
      },
      stack: {
        title: 'Toute la chaîne des miles',
        sub: 'Hubs, portails, tracking & analytics dans une stack',
      },
    },
    tableSection: {
      title: 'En un coup d’œil : exécution agentique vs stacks typiques',
      description:
        'Les éditeurs diffèrent — utilisez la grille ci-dessous pour votre outil exact. Ce tableau résume les écarts récurrents quand les équipes dépassent les point solutions et veulent une couche d’automatisation sur tout le réseau.',
      badge: 'Vue agrégée transparente',
    },
    aggregateFeatures: [
      'AI Command Centre & AI Agents',
      'Allocation auto chauffeurs & transporteurs',
      'Planification agentique des tournées',
      'Premier / dernier mile',
      'Expéditions multi-segments',
      'Portail expéditeur',
      'Suivi en temps réel',
      'Alertes & notifications IA',
      'Analytics',
    ],
    aggregateGeofleetCells: [
      'AI Command Centre avec AI Agents : orchestration autonome multi-étapes, gestion des exceptions et optimisation continue — pas un chatbot add-on ni un dashboard statique.',
      'Allocation IA chauffeurs et transporteurs dans un même modèle — capacité, proximité, SLA, coût, compétences et conditions live mises à jour depuis le centre de commande.',
      'Planification de tournées ML et réoptimisation dynamique face au trafic, nouvelles commandes, échecs, hubs et contraintes — sans marathons de replanification manuelle.',
      'Premier, moyen et dernier mile dans une seule plateforme d’automatisation logistique.',
      'Modélisez des flux multi-segments et hubs complexes — pas seulement des boucles chauffeur simples.',
      'Portails expéditeur & transporteur dédiés : réservation, visibilité et collaboration.',
      'Suivi live, ETAs prédictives et expérience de marque alimentées par la même couche IA opérationnelle.',
      'Alertes intelligentes priorisées et notifications déclenchées par IA pour risque SLA, retards, capacité et exceptions.',
      'Analytics opérationnels et insights assistés par IA sur hubs, transporteurs, tournées, chauffeurs et SLAs.',
    ],
    aggregateCompetitorCells: [
      'Beaucoup de produits offrent dashboards, règles ou chat add-on — peu livrent des AI Agents autonomes natifs sur dispatch, routes, replanification et exceptions dans une seule tour.',
      'L’affectation chauffeur ou tâche est courante ; un moteur unique qui optimise chauffeurs et transporteurs ensemble sur des SLAs live reste rare.',
      'Beaucoup optimisent des routes statiques ou des batchs journaliers ; moins replanifient en continu quand trafic, échecs, hubs et nouvelles commandes changent le board en temps réel.',
      'Le dernier mile et la messagerie locale sont bien servis ; premier et moyen mile et handoffs réseau demandent souvent d’autres outils ou intégrations.',
      'Les boucles chauffeur mono-segment sont typiques ; modéliser hub-à-hub et multi-segments en premier citoyen est plus rare hors suites enterprise.',
      'Portails expéditeur/transporteur existent dans certains stacks, mais profondeur, UX et parité avec les outils ops varient fortement.',
      'Tracking et ETAs sont standards ; lier l’expérience client à la même couche IA que le dispatch est moins universel.',
      'Les notifications sont souvent des templates ; des alertes proactives priorisées par risque SLA sur tout le réseau sont un niveau au-dessus.',
      'Les KPIs tournée/tâche sont courants ; des analytics unifiés hubs, transporteurs, segments et SLAs dans une plateforme d’automatisation sont plus difficiles à trouver.',
    ],
    vendorsSection: {
      eyebrow: 'Pages comparatives',
      title: 'Trouvez votre éditeur actuel',
      description:
        'Chaque lien ouvre une comparaison dédiée : forces de l’éditeur, où Geofleet va plus loin, et quand une plateforme logistique agentique est le meilleur choix.',
      vsPrefix: 'Geofleet vs',
      alternativeSuffix: 'alternative',
      openLink: 'Ouvrir la comparaison',
    },
    cta: {
      headline: 'Voir Geofleet sur votre réseau',
      subtext:
        'Parcourez l’AI Command Centre, l’allocation et le routing agentique avec vos hubs, transporteurs et SLAs — pas un deck générique.',
    },
    faqTitle: 'FAQ',
    faqs: [
      {
        question: 'Qu’est-ce qu’une plateforme logistique agentique ?',
        answer:
          'Une plateforme agentique utilise des AI Agents et un centre de commande pour orchestrer le travail de façon autonome : allocation, routes, replanification, alertes et communications clients réagissent au live plutôt que de s’appuyer uniquement sur des règles statiques ou des clics dispatch manuels.',
      },
      {
        question: 'Comment Geofleet se compare-t-il aux optimiseurs de tournées ?',
        answer:
          'Les optimiseurs se concentrent sur l’ordonnancement des arrêts. Geofleet traite le routing comme partie d’une exécution complète — allocation auto chauffeurs et transporteurs, flux multi-segments et hubs, portails expéditeur/transporteur, tracking et analytics — pour que les plans optimisés tiennent en opérations.',
      },
      {
        question: 'Comment Geofleet se compare-t-il aux logiciels du dernier mile ?',
        answer:
          'Les outils dernier mile tournent souvent autour des tâches, chauffeurs ou livraison locale. Geofleet vise l’automatisation logistique de bout en bout, y compris moyen et premier mile si besoin, écosystèmes partenaires et gouvernance SLA à l’échelle.',
      },
      {
        question: 'Où voir un face-à-face avec un éditeur précis ?',
        answer:
          'Descendez vers la grille éditeurs — chaque carte mène à une page Geofleet vs éditeur avec détail des capacités et des compromis honnêtes.',
      },
      {
        question: 'Dois-je réserver une démo pour comparer ?',
        answer:
          'Oui. Les démos sont le plus rapide pour mapper vos hubs, transporteurs, volumes et intégrations vers le centre de commande et les AI Agents Geofleet.',
      },
    ],
  },
};
